module.exports = __webpack_public_path__ + "img/loginBg.b252ba71.jpg";